<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>KRÉTA hozzáférésem</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Saját KRÉTA belépés a szinkronhoz</ion-card-title>
      <ion-card-subtitle>
        A szinkron a Te nevedben lép be a KRÉTA-ba és írja be az óráidat, ezért a saját
        belépési adataidat kell megadnod. Ezt az oldalt csak Te látod – más pedagógus
        adatait nem mutatjuk.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-spinner name="crescent" *ngIf="toltodik"></ion-spinner>

      <div class="kreta-allapot hianyzik" *ngIf="adat && !adat.beallitva">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <div>
          <b>Nincs beállítva a KRÉTA felhasználód</b> – a szinkron a Te óráidat nem tudja
          beírni. Add meg alább.
        </div>
      </div>
      <div class="kreta-allapot kesz" *ngIf="adat?.beallitva">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        <div>
          Beállítva: <b>{{ adat.kreta_user }}</b>
          <span *ngIf="!adat.van_jelszo"> – de <b>jelszó nélkül</b>, így a szinkron nem tud belépni.</span>
          <div class="sugo" *ngIf="adat.utolso_futas">
            Utolsó futás: {{ adat.utolso_futas | date:'yyyy-MM-dd HH:mm' }}
            <span *ngIf="adat.utolso_eredmeny">– {{ adat.utolso_eredmeny }}</span>
          </div>
        </div>
      </div>

      <div class="urlap">
        <ion-input fill="outline" label="KRÉTA felhasználónév" labelPlacement="stacked"
                   [(ngModel)]="urlap.kreta_user" placeholder="a KRÉTA belépési neved"></ion-input>
        <ion-input fill="outline" label="KRÉTA jelszó" labelPlacement="stacked" type="password"
                   [(ngModel)]="urlap.kreta_pass"
                   [placeholder]="adat?.van_jelszo ? 'Beállítva – üresen hagyva megmarad' : 'add meg a jelszavad'"></ion-input>
        <ion-input fill="outline" label="Kétlépcsős azonosítás kulcsa (ha van)" labelPlacement="stacked"
                   type="password" [(ngModel)]="urlap.kreta_totp"
                   [placeholder]="adat?.van_totp ? 'Beállítva – üresen hagyva megmarad' : 'nem kötelező'"></ion-input>
        <div class="sugo">
          A jelszót és a kulcsot titkosítva tároljuk, és soha nem olvassuk vissza a képernyőre –
          csak azt jelezzük, hogy be van-e állítva. Üresen hagyva a korábbi megmarad, így a
          felhasználónév önmagában is módosítható.
        </div>
        <div class="gombsor">
          <ion-button color="success" (click)="ment()" [disabled]="mentes || ellenorzes">
            <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
          </ion-button>
          <!-- A mentés nem bizonyít semmit: a rossz jelszó csak a következő szinkronon
               derülne ki. Ez tényleg belép a KRÉTÁ-ba a megadott adatokkal. -->
          <ion-button fill="outline" (click)="ellenoriz()" [disabled]="mentes || ellenorzes">
            <ion-spinner name="crescent" slot="start" *ngIf="ellenorzes"></ion-spinner>
            <ion-icon slot="start" name="log-in-outline" *ngIf="!ellenorzes"></ion-icon>
            {{ ellenorzes ? 'Belépés folyamatban…' : 'Belépés ellenőrzése' }}
          </ion-button>
        </div>
        <div class="sugo" *ngIf="ellenorzes">
          Most valóban belépünk a KRÉTÁ-ba a megadott adatokkal – ez fél-egy percig is eltarthat.
          Semmit nem írunk be és nem naplózunk, csak megnézzük, átmegy-e a belépés.
        </div>

        <div class="kreta-allapot kesz" *ngIf="eredmeny?.ok">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <div>
            <b>Az adatok jók.</b> {{ eredmeny.uzenet }}
            <div class="sugo" *ngIf="eredmeny.kreta_host">KRÉTA: {{ eredmeny.kreta_host }}</div>
            <div class="sugo" *ngIf="eredmeny.ketlepcsos">
              A kétlépcsős azonosítás kulcsa is működik (a kódot a rendszer magától állítja elő).
            </div>
          </div>
        </div>
        <div class="kreta-allapot hianyzik" *ngIf="eredmeny && !eredmeny.ok">
          <ion-icon name="close-circle-outline"></ion-icon>
          <div>
            <b>A belépés nem sikerült.</b>
            <div>{{ eredmeny.error }}</div>
            <!-- A rossz cím a leggyakoribb ok: mutassuk meg, hova próbáltunk belépni. -->
            <div class="sugo" *ngIf="eredmeny.kreta_host">
              Ezt a címet használtuk: <b>{{ eredmeny.kreta_host }}</b>. Ha ez nem a ti KRÉTÁ-tok,
              az intézményi adminnál állítható (Admin → KRÉTA naplózás → KRÉTA cím).
            </div>
          </div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
